<script lang="ts" setup>
import { i18n } from '@/i18n';
import TableHead from '../TableHead.vue';
import { TableContentProperty, UniqueHeaderKey } from '../../interface/tableContentHeaders';
import ArrowIcon from '../../components/ArrowIcon.vue';
import { UniqueTableContentViewModel } from './uniqueTableContentViewModel';

// props
const props = withDefaults(
  defineProps<{
    header: TableContentProperty;
    headerKey: UniqueHeaderKey;
    headerIndex: number;
    accumulationTableContentWidth: number;
    isVariableWidth: boolean;
    isAllSelected: boolean;
    stableColumnCount: number;
  }>(),
  {}
);

// emits
const emits = defineEmits<{
  (e: 'onClickSort', index: number, key: TableContentProperty, isAsc: boolean): void;
  (e: 'onMousedownResizer', event: MouseEvent, headerIndex: number): void;
}>();
//変数
const t = i18n.t;
const uniqueTableContentVM = new UniqueTableContentViewModel();
</script>

<template>
  <TableHead
    :class="[uniqueTableContentVM.isSticky(stableColumnCount, headerIndex) ? 'sticky-content' : '']"
    :style="{
      left: uniqueTableContentVM.calcStickyDiff(stableColumnCount, headerIndex, accumulationTableContentWidth),
      opacity: 0,
    }"
    :index="headerIndex"
    :resizable="
      // 幅可変な列 && 固定する列に含まれていない -> 可変幅
      header.isVariableWidth && !uniqueTableContentVM.isSticky(stableColumnCount, headerIndex)
    "
    @on-mousedown-resizer="($event) => emits('onMousedownResizer', $event, headerIndex)"
  >
    <template v-if="header.sortOption.isSortable">
      <div class="table-header__sortable-content">
        <div class="table-header__text">{{ uniqueTableContentVM.uniqueHeader(headerKey) }}</div>
        <ArrowIcon :asc="header.sortOption.isAsc" @on-click="emits('onClickSort', headerIndex, header, header.sortOption.isAsc)" />
      </div>
    </template>
    <template v-else>
      <div class="table-header__text">{{ uniqueTableContentVM.uniqueHeader(headerKey) }}</div>
    </template>
  </TableHead>
</template>

<style scoped lang="scss"></style>
